import { useContext } from "react";
import { SharedOrganizationContext } from "./SharedOrganizationContext";

const useSharedOrganization = () => useContext(SharedOrganizationContext);

export default useSharedOrganization;
